import { render } from "./OfferTerms.vue?vue&type=template&id=22fae95a&scoped=true"
import script from "./OfferTerms.vue?vue&type=script&lang=js"
export * from "./OfferTerms.vue?vue&type=script&lang=js"

import "./OfferTerms.vue?vue&type=style&index=0&id=22fae95a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22fae95a"]])

export default __exports__